import React, {Component} from 'react';
import { connect } from 'react-redux';
import LastComments from "../lastcomments/lastcomments.component";
import EditFavoriteGenres from "../editfavoritegenres/editfavoritegenres.component";
import EditNotification from "../editnotification/editnotification.component";
import Spinner from '../../../SHARED/components/spinner/spinner.component';
import EditUserDetails from '../../../SHARED/components/editUserDetails/editUserDetails.component';
import { getUserProfile } from '../../../SHARED/actions/editprofile.actions';
import {LOGIN_ROUTE} from '../../../SHARED/config/routes';
import {withRouter} from 'react-router';
import { Helmet } from 'react-helmet';
import { pageViewEvent } from '../../../SHARED/helpers/general.helper';
class EditProfile extends Component {

    componentWillMount() {
        window.scrollTo(0, 0);
        if (!this.isUserAuthenticated()) {
            this.props.history.push(LOGIN_ROUTE);
        }
    }

    componentDidMount() {
        pageViewEvent('Editare profil - Cinemap', window.location.href);
    }

    isUserAuthenticated = () => {
        return localStorage.getItem('login_type') === 'authenticated' ? true : false;
    };

    notificationSettings = () => {
        if(this.props.userProfile) {
            if (this.props.userProfile.notification_account && this.props.userProfile.notification_email) {
                let notifications = {
                    notificationAccount: [],
                    notificationEmail: []
                };
                this.props.userProfile.notification_account.map(notification => notifications.notificationAccount.push(notification.id))
                this.props.userProfile.notification_email.map(notification => notifications.notificationEmail.push(notification.id))
                return notifications;
            }
        }
    }

    getFavoriteGenres = () => {
        if(this.props.userProfile) {
            if (this.props.userProfile.fav_genres) {
                let fav_genres = [];
                this.props.userProfile.fav_genres.map(gender => fav_genres.push(gender.id));

                return fav_genres;
            }
        }
    }
    
    render() {
        return(
           <div className="edit-profile-page">
                <Spinner />
                <Helmet>
                    <title>Editare profil - Cinemap</title>
                    <meta name="description" content="Pagina de editare a profilului tău."/>
                    <link rel="canonical" href={window.location.href}/>
                </Helmet>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-9"> 
                            <EditUserDetails />
                            <EditFavoriteGenres favGenres={this.getFavoriteGenres()} />
                            <EditNotification notification={this.notificationSettings()} />
                        </div>
                        <div className="col-lg-3">
                            <LastComments />
                        </div>
                    </div>
                </div>
           </div>
        )
    }
}

const mapStateToProps = state => ({
    userProfile: state.profile.userDetails
})

export default withRouter(connect(mapStateToProps, {getUserProfile})(EditProfile));


// WEBPACK FOOTER //
// ./src/FO/components/editprofile/editprofile.component.js